import * as React from "react";

import type { MenuOpenOnExecuteParameter } from "@1js/acui-common";
import { useToggleExpandedState } from "./useToggleExpandedState";
import type { AppPreviewGalleryInternalState } from "../next";

export const useOnExecute = (
  onMenuButtonExecute: (parameter: MenuOpenOnExecuteParameter) => void,
  state: AppPreviewGalleryInternalState,
  setState: React.Dispatch<React.SetStateAction<AppPreviewGalleryInternalState>>
) => {
  const toggleExpandedState = useToggleExpandedState(state, setState);

  const onExecute = React.useCallback(
    (parameter: MenuOpenOnExecuteParameter) => {
      onMenuButtonExecute(parameter);
      if (!parameter.isShadowRendering) {
        toggleExpandedState();
      }
    },
    [onMenuButtonExecute, toggleExpandedState]
  );

  return onExecute;
};
